import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { empty, ifElse, includes, head, filter, propEq } from 'ramda';
import { Container, Slot } from './timeSlots.styles';
import { slotPropType } from '../../../../propTypes';

export class TimeSlots extends PureComponent {
  static propTypes = {
    slots: PropTypes.arrayOf(slotPropType),
    activeSlots: PropTypes.array,
    onSlotSelected: PropTypes.func,
    onSlotUnselected: PropTypes.func,
  };

  static defaultProps = {
    slots: [],
    onSlotSelected: empty,
    onSlotUnselected: empty,
    activeSlots: [],
  };

  componentDidMount() {
    this.autoSelectIfSingle();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.slots !== this.props.slots) {
      this.autoSelectIfSingle();
    }
  }

  autoSelectIfSingle = () => {
    const activeSlots = filter(propEq('isActive', true))(this.props.slots);

    if (activeSlots.length === 1) {
      this.props.onSlotSelected(head(activeSlots));
    }
  };

  isSlotSelected = slot => includes(slot, this.props.activeSlots);

  handleSlotToggled = ifElse(this.isSlotSelected, this.props.onSlotUnselected, this.props.onSlotSelected);

  render() {
    return (
      <Container>
        {this.props.slots.map(slot => {
          const { start, end, isActive } = slot;
          return (
            <Slot
              key={[start, end].join('_')}
              isActive={isActive}
              isSelected={this.isSlotSelected(slot)}
              onClick={() => this.handleSlotToggled(slot)}
            >
              {start} - {end}
            </Slot>
          );
        })}
      </Container>
    );
  }
}
